export default [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home"),
    meta: {
      roles: ["distributor", "customer"],
    },
    children: [
      {
        path: "/message",
        name: "HomeMessage",
        component: () => import("@/views/Message"),
        meta: {
          roles: ["distributor", "customer"],
        },
        children: [
          {
            path: 'messageDetail',
            name: 'HomeMessageDetail',
            component: () => import('@/views/Message/detail'),
            meta: {
              roles: ["distributor", "customer"],
            }
          }
        ]
      },
      {
        path: "/searchPage",
        name: "SearchPage",
        component: () => import("@/views/Search/search"),
        meta: {
          roles: ["distributor", "customer"],
        },
        children: [
          {
            path: "searchResult/:text",
            name: "SearchResult",
            component: () => import("@/views/Search/result"),
            meta: {
              roles: ["distributor", "customer"],
            },
            children: [
              {
                path: "goodsDetail/:id",
                name: "SearchGoodsDetail",
                component: () => import("@/views/GoodsDetail"),
                meta: {
                  roles: ["distributor", "customer"],
                },
              },
            ],
          },
        ],
      },
      {
        path: "/brandList",
        name: "BrandList",
        component: () => import("@/views/BrandList"),
        meta: {
          roles: ["distributor", "customer"],
        },
      },
      {
        path: "/brandPlace/:partId",
        name: "BrandPlace",
        component: () => import("@/views/BrandPlace"),
        meta: {
          roles: ["distributor", "customer"],
        },
        children: [
          {
            path: "cateGoods",
            name: "CateGoods",
            component: () => import("@/views/BrandPlace/cateGoods"),
            meta: {
              roles: ["distributor", "customer"],
            },
          },
          {
            path: "goodsDetail/:id",
            name: "BrandPlaceGoodsDetail",
            component: () => import("@/views/GoodsDetail"),
            meta: {
              roles: ["distributor", "customer"],
            },
          },
        ],
      },
      {
        path: "/homeGoodsDetail/:id",
        name: "HomeGoodsDetail",
        component: () => import("@/views/GoodsDetail"),
        meta: {
          roles: ["distributor", "customer"],
        },
      },
      {
        path: "/homeSuitGoods",
        name: "HomeSuitGoods",
        component: () => import("@/views/ActivityPlace/suitGoods"),
        meta: {
          roles: ["distributor", "customer"],
        },
      },
      {
        path: "/homeSuitGoodsDetail/:id",
        name: "HomeSuitGoodsDetail",
        component: () => import("@/views/GoodsDetail"),
        meta: {
          roles: ["distributor", "customer"],
        },
      },
      {
        path: "/topList",
        name: "TopList",
        component: () => import("@/views/TopList/index"),
        meta: {
          roles: ["distributor", "customer"],
        },
        children: [
          {
            path: "topListGoodsDetail/:id",
            name: "TopListGoodsDetail",
            component: () => import("@/views/GoodsDetail"),
            meta: {
              roles: ["distributor", "customer"],
            },
          },
        ]
      },
      {
        path: '/freeGoods',
        name: 'FreeGoods',
        component: () => import('@/views/FreeGoods/index'),
        meta: {
          roles: ['distributor', 'customer'],
        }
      },
      {
        path: '/newcomer',
        name: 'Newcomer',
        component: () => import('@/views/Newcomer/index'),
        meta: {
          roles: ['distributor', 'customer'],
        },
        children: [
          {
            path: "newcomerGoodsDetail/:id",
            name: "NewcomerGoodsDetail",
            component: () => import("@/views/GoodsDetail"),
            meta: {
              roles: ["distributor", "customer"],
            },
          },
          {
            path: "newcomerSuitGoods",
            name: "NewcomerSuitGoods",
            component: () => import("@/views/ActivityPlace/suitGoods"),
            meta: {
              roles: ["distributor", "customer"],
            },
          },
          {
            path: "newcomerSuitGoodsDetail/:id",
            name: "NewcomerSuitGoodsDetail",
            component: () => import("@/views/GoodsDetail"),
            meta: {
              roles: ["distributor", "customer"],
            },
          },
        ]
      },
    ],
  },
];
